import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../../i18n/LanguageContext';
import { useCookieConsent } from '../../site/CookieConsent';

/** Fixed brand logo (master vector artwork) — white version for the dark footer. */
const LOGO_WHITE = `${process.env.PUBLIC_URL}/rts-logo-white.svg`;

const LEGAL_LABELS: Record<string, { privacy: string; terms: string; cookie: string; prefs: string; login: string }> = {
  de: { privacy: 'Datenschutz', terms: 'AGB', cookie: 'Cookie-Richtlinie', prefs: 'Cookie-Einstellungen', login: 'Mitarbeiter-Login' },
  en: { privacy: 'Privacy Policy', terms: 'Terms & Conditions', cookie: 'Cookie Policy', prefs: 'Cookie Preferences', login: 'Staff Login' },
  it: { privacy: 'Privacy Policy', terms: 'Termini e Condizioni', cookie: 'Cookie Policy', prefs: 'Preferenze cookie', login: 'Area riservata' },
};

const Footer: React.FC = () => {
  const { t, lang } = useI18n();
  const { reopen } = useCookieConsent();
  const L = LEGAL_LABELS[lang] || LEGAL_LABELS.de;

  return (
    <footer>
      <div className="footer-inner">
        <div className="footer-grid">
          <div>
            <img className="footer-logo" src={LOGO_WHITE} alt="RTS S.p.A." height={40} style={{ height: 40, width: 'auto' }} />
            <p className="footer-desc" dangerouslySetInnerHTML={{ __html: t('ft.desc') }} />
          </div>
          <div>
            <div className="footer-col-title">{t('ft.prod')}</div>
            <ul className="footer-links">
              <li><Link to="/prodotti">{t('ft.p1')}</Link></li>
              <li><Link to="/prodotti">{t('ft.p2')}</Link></li>
              <li><Link to="/prodotti">{t('ft.p3')}</Link></li>
              <li><Link to="/prodotti">{t('ft.p4')}</Link></li>
              <li><Link to="/prodotti">{t('ft.p5')}</Link></li>
              <li><Link to="/prodotti">{t('ft.p6')}</Link></li>
            </ul>
          </div>
          <div>
            <div className="footer-col-title">{t('ft.svc')}</div>
            <ul className="footer-links">
              <li><Link to="/servizi">{t('ft.s1')}</Link></li>
              <li><Link to="/servizi">{t('ft.s2')}</Link></li>
              <li><Link to="/servizi">{t('ft.s3')}</Link></li>
            </ul>
          </div>
          <div>
            <div className="footer-col-title">{t('ft.con')}</div>
            <ul className="footer-links">
              <li><a href={`mailto:${t('info.email')}`}>{t('info.email')}</a></li>
              <li><a href={`tel:${t('info.north.phoneHref')}`}>{t('info.north.phone')}</a></li>
              <li>
                <a
                  href="https://www.linkedin.com/company/rts-spa"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  LinkedIn
                </a>
              </li>
              <li style={{ marginTop: '.5rem', color: 'rgba(255,255,255,.62)', fontSize: '.8rem' }}>{t('ft.net')}</li>
            </ul>
            <ul className="footer-links" style={{ marginTop: '1rem' }}>
              <li><Link to="/privacy-policy">{L.privacy}</Link></li>
              <li><Link to="/terms-and-conditions">{L.terms}</Link></li>
              <li><Link to="/cookie-policy">{L.cookie}</Link></li>
              <li><a href="#cookie" onClick={(e) => { e.preventDefault(); reopen(); }}>{L.prefs}</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <span>
            <span dangerouslySetInnerHTML={{ __html: t('ft.copyright') }} />
            {/* Reveal once Axis Group is officially announced: remove the `hidden` attribute */}
            <span hidden> · {t('info.group')}</span>
          </span>
          <span className="footer-bottom-right">
            <span>{t('ft.rights')}</span>
            <Link to="/admin/login" className="footer-login">{L.login}</Link>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
